import React from 'react';
import PropTypes from 'prop-types';
import { StyledInput } from '../text-field/styles.js';

const TextArea = React.forwardRef(({ error, short, ...rest }, ref) => (
  <StyledInput
    as="textarea"
    $error={error}
    $short={short}
    {...rest}
    ref={ref}
    data-input-scroll-id={rest.name}
  />
));

TextArea.displayName = 'TextArea';

TextArea.propTypes = {
  error: PropTypes.bool,
  short: PropTypes.bool,
};

export default TextArea;
